module.exports = __webpack_public_path__ + "static/logo-125b63d01146a8904153fe126926a2a4.png";